// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__89Vdt","alert":"SettungsInbox_alert__3P9_Y"};